import {
  UPDATE_USER_CREDENTIALS,
  LOGOUT_USER,
  START_LOADING,
  STOP_LOADING
} from './types';

export const updateUserDetails = (userData) => {
  return {
    type: UPDATE_USER_CREDENTIALS,
    payload: userData
  };
};

export const logoutUser = () => {
  return {
    type: LOGOUT_USER
  };
};

export const startLoading = () => {
  return {
    type: START_LOADING
  };
};

export const stopLoading = () => {
  return {
    type: STOP_LOADING
  };
};
